import { ACCESS_TOKEN } from 'src/constants/access-token';
export const setAuthorization = (token:string) => {
  localStorage.setItem(ACCESS_TOKEN,token);
};